/* ==========================================================================
   SPIRO+ MY — sections-b.js
   Interactivity for: usp (carousel), comparison (competitor switcher),
   pre-clinical-cta-banner (jump-to-package)
   ========================================================================== */
(function () {
  'use strict';

  /* ---------------- USP carousel ---------------- */
  document.querySelectorAll('[data-usp]').forEach(function (section) {
    var track = section.querySelector('[data-usp-track]');
    var prevBtn = section.querySelector('[data-usp-prev]');
    var nextBtn = section.querySelector('[data-usp-next]');
    if (!track) return;

    function scrollByCard(direction) {
      var slide = track.querySelector('[data-usp-slide]');
      var amount = slide ? slide.getBoundingClientRect().width + 14 : track.clientWidth * 0.8;
      track.scrollBy({ left: amount * direction, behavior: 'smooth' });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { scrollByCard(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollByCard(1); });

    function updateNavState() {
      if (!prevBtn || !nextBtn) return;
      var maxScroll = track.scrollWidth - track.clientWidth - 2;
      prevBtn.disabled = track.scrollLeft <= 2;
      nextBtn.disabled = track.scrollLeft >= maxScroll;
    }
    track.addEventListener('scroll', updateNavState, { passive: true });
    updateNavState();
  });

  /* ---------------- Comparison competitor switcher ---------------- */
  document.querySelectorAll('[data-comparison]').forEach(function (section) {
    var select = section.querySelector('[data-comparison-select]');
    if (!select) return;

    var nameEl = section.querySelector('[data-comparison-name]');
    var subtitleEl = section.querySelector('[data-comparison-subtitle]');
    var scoreEl = section.querySelector('[data-comparison-score]');
    var valueGroups = section.querySelectorAll('[data-comparison-values]');

    function applySelection() {
      var option = select.options[select.selectedIndex];
      var index = select.value;

      if (nameEl && option) nameEl.textContent = option.getAttribute('data-name') || '';
      if (subtitleEl && option) subtitleEl.textContent = option.getAttribute('data-subtitle') || '';
      if (scoreEl && option) scoreEl.textContent = option.getAttribute('data-score') || '';

      valueGroups.forEach(function (group) {
        var slots = group.querySelectorAll('[data-slot-index]');
        slots.forEach(function (slot) {
          if (slot.getAttribute('data-slot-index') === index) {
            slot.removeAttribute('hidden');
          } else {
            slot.setAttribute('hidden', '');
          }
        });
      });
    }

    select.addEventListener('change', applySelection);
    applySelection();
  });

  /* ---------------- Pre-clinical CTA: jump to hero + preselect package ---------------- */
  document.querySelectorAll('[data-jump-to-package]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var hero = document.getElementById('hero');
      var index = parseInt(btn.getAttribute('data-package-index'), 10);
      if (isNaN(index)) index = 0;

      if (hero) {
        hero.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      var packageCards = document.querySelectorAll('[data-package-card]');
      if (packageCards.length) {
        var target = packageCards[index] || packageCards[0];
        // Let the scroll begin before triggering selection so any focus jump feels natural.
        window.setTimeout(function () {
          target.click();
        }, 300);
      }
    });
  });
})();
